<template>
	<section class="page page-extras-scorekeeper">
		<!-- Do nothing -->
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageExtrasScorekeeper extends PageBase {}
</script>

<style lang="scss">
	.page-extras-scorekeeper {
		// Not implemented
	}
</style>
